<template>
  <div ref="chart" class="horizontal-bar-chart w-full fill-Primary-800"></div>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "HorizontalBarChart",
  props: {
    data: {
      type: Array,
      required: true,
    },
    formater: {
      type: Function,
      default: (d) => d,
    },
  },
  mounted() {
    if (this.data.length > 0) {
      this.drawHorizontalBarChart()
    }
  },
  watch: {
    data:function(value) {
      if (this.data.length > 0) {
        this.drawHorizontalBarChart()
      }
    }
  },
  methods: {
    drawHorizontalBarChart() {
      const margin = { top: 20,bottom: 24, left: 20, right: 6 };
      const width = this.$refs.chart.getBoundingClientRect().width - margin.right - margin.left;
      const height = this.data.length * 24;
      this.$refs.chart.innerHTML = '';
      const svg = d3
        .select(this.$refs.chart)
        .append("svg")
        .attr("height", height + margin.top + margin.bottom)
        .attr("width", "100%")
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      const x = d3.scaleLinear().range([0, width]);
      const y = d3.scaleBand().range([0,height]).padding(0.1);

      x.domain([0, d3.max(this.data, (d) => d.value)]);
      y.domain(this.data.map((d) => d.label));

      svg
        .append("g")
        .attr("class", "grid-lines-x")
        .attr("transform", `translate(0,${height})`)
        .call(
          d3
            .axisBottom(x)
            .tickSize(-height)
            .ticks(8)
            .tickFormat(this.formater)
            
        );

      const bars = svg.selectAll(".bar").data(this.data);

      bars
        .enter()
        .append("rect")
        .attr("class", "bar hover:opacity-60 cursor-pointer")
        .attr("y", (d) => y(d.label) + 6)
        .attr("height", 5.5)
        .attr("x", 0)
        .attr("width", (d) =>  x(d.value)+'px')
        .on('click', (event,d) => {
          navigateTo('/recipients/' + d.recipient_code)
        });


      //svg.append("g").attr("class", "x-axis").attr("transform", `translate(0,${height})`).call(d3.axisBottom(x));
      svg.append("g").attr("class", "y-axis").call(d3.axisLeft(y));
      // Add the y-axis links after drawing the chart elements
      const yAxisLabels = d3.selectAll(".y-axis .tick text");
      const labels = svg.selectAll(".label").data(this.data);
      // Hide tick line
      svg.append("g").attr("class", "y-axis").call(d3.axisLeft(y).tickSize(0)); // Remove tick lines from y-axis

    },
  },
};
</script>

<style>
.horizontal-bar-chart {
  /* Add any styling for the horizontal bar chart container here if needed */
}
.grid-lines-x line {
  stroke: #D4D5E1;
  opacity: 0.6;
}
.grid-lines-x .domain,
.x-axis .domain,
.x-axis .tick line,
.y-axis .domain,
.y-axis .tick {
  display: none;
}
.x-axis .tick text {
  font-size: 13px !important;
  color: #8E92B2 !important;
}

</style>
